module.exports = __webpack_public_path__ + "static/Default-Profile@2x-4bfd7b261490c07bcc18c0acfc32b7bd.png";